// extracted by mini-css-extract-plugin
export default {"list":"list--AqMy9","fullWidth":"fullWidth--AqMy9"};